import { httpsCallable } from 'firebase/functions';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';
import { Timestamp } from 'shared/types/timestamp';

import { getFunctions } from './helpers';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
  timezone: string;
};

export const getExternalCalendarEvents = async ({
  startDate,
  endDate,
  timezone,
}: Options) => {
  const functions = getFunctions();
  const fetchEvents = httpsCallable<
    { startDate: string; endDate: string; timezone: string },
    ExternalCalendarEvent[]
  >(functions, 'externalCalendars-getEvents');

  const { data } = await fetchEvents({
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
    timezone,
  });
  return data;
};
